export default __webpack_public_path__ + "static/media/YAS0930.34I-42365_-25400_0.64b2b6f4.jpg";